// global public variable
export const globalCommon = {
	// token storage field name
	TOKEN_KEY: 'agent_mobile_token',
	// token default expiration time (10 hours)
	TOKEN_DEFAULT_EXPIRES: 3600000,
	// cookie expiration field name
	EXPIRES_KEY: 'agent_mobile_expires',
	// Current time distance expiration time limit configuration (less than 10 minutes is considered expired)
	TOKEN_VALIDE_LIMIT: 10 * 60 * 1000
}
